import * as runtimeCore from '@module-federation/runtime-core';

export * from '@module-federation/runtime-core';

export default runtimeCore;
